import { useQuery } from "@apollo/client";
import { getFragmentData, graphql } from "../gql";
import { FranchiseeFragment } from "./FranchiseeFragment.ts";
import { FranchiseeItemFragment } from "../gql/graphql.ts";

export const GetAllFranchiseesQuery = graphql(`
  query getAllFranchisees($isOneOnOne: Boolean, $isInternal: Boolean) {
    getAllFranchisees(isOneOnOne: $isOneOnOne, isInternal: $isInternal) {
      ...FranchiseeItem
    }
  }
`);
export function useAllFranchisees(params?: {
  isOneOnOne?: boolean;
  isInternal?: boolean;
}) {
  const { data, loading } = useQuery(GetAllFranchiseesQuery, {
    fetchPolicy: "cache-and-network",
    variables: {
      isOneOnOne: params?.isOneOnOne,
      isInternal: params?.isInternal,
    },
  });

  return {
    franchisees: (getFragmentData(
      FranchiseeFragment,
      data?.getAllFranchisees,
    ) ?? []) as FranchiseeItemFragment[],
    loading,
  };
}
